import React, {useContext, useEffect, useState} from "react";
import {
  CircularProgress, Stack,
} from "@mui/material";
import {Context as AppContext} from "../../context/AppContext";
import {ProjectRichTableView} from "./components/project-rich-table-view";

export const Projects = () => {
  const {getUserProjects} = useContext(AppContext);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getUserProjects({setLoading})
  }, []);

  return (
      <>
        <ProjectRichTableView/>
        {loading ? <Stack alignItems={"center"} justifyContent={"center"}><CircularProgress/></Stack> : null}
      </>
  )
}
